import React from 'react';
import { Edit, Trash2, KeyRound, Shield } from 'lucide-react';

export const UserTable = ({ users, onEdit, onResetPassword, onDelete, onToggleStatus }) => {
  return (
    <div className="bg-black/40 backdrop-blur-sm rounded-lg border border-orange-500/30 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-orange-500/10 border-b border-orange-500/30">
            <tr>
              <th className="px-6 py-4 text-left text-sm font-semibold text-orange-400">Username</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-orange-400">Email</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-orange-400">Role</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-orange-400">Status</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-orange-400">Created</th>
              <th className="px-6 py-4 text-right text-sm font-semibold text-orange-400">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-orange-500/20">
            {users.map((user) => (
              <tr key={user.id} className="hover:bg-orange-500/5 transition-colors">
                <td className="px-6 py-4 text-white font-medium">{user.username}</td>
                <td className="px-6 py-4 text-gray-300">{user.email}</td>
                <td className="px-6 py-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                    user.role === 'admin' ? 'bg-orange-500/20 text-orange-400' :
                    user.role === 'editor' ? 'bg-blue-500/20 text-blue-400' :
                    'bg-gray-500/20 text-gray-400'
                  }`}>{user.role}</span>
                </td>
                <td className="px-6 py-4">
                  <button onClick={() => onToggleStatus(user)}
                    className={`px-3 py-1 rounded-full text-xs font-medium ${
                      user.is_active ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'
                    }`}>
                    {user.is_active ? 'Active' : 'Inactive'}
                  </button>
                </td>
                <td className="px-6 py-4 text-gray-400 text-sm">{new Date(user.created_at).toLocaleDateString()}</td>
                <td className="px-6 py-4">
                  <div className="flex justify-end space-x-2">
                    <button onClick={() => onEdit(user)} className="p-2 text-blue-400 hover:bg-blue-500/20 rounded-lg transition-colors" title="Edit user">
                      <Edit className="w-4 h-4" />
                    </button>
                    <button onClick={() => onResetPassword(user)} className="p-2 text-green-400 hover:bg-green-500/20 rounded-lg transition-colors" title="Reset password">
                      <KeyRound className="w-4 h-4" />
                    </button>
                    <button onClick={() => onDelete(user)} className="p-2 text-red-400 hover:bg-red-500/20 rounded-lg transition-colors" title="Delete user">
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {users.length === 0 && (
        <div className="text-center py-12 text-gray-400">
          <Shield className="w-12 h-12 mx-auto mb-4 opacity-50" />
          <p>No users found. Create your first user to get started.</p>
        </div>
      )}
    </div>
  );
};
